import { Resource } from './resource';

export class ServerResponse{

    content: any;
    totalPages: Number;
    totalRecords: Number;
    pageSize: Number;
    status: Number;
    message: string;
    errorMessage: string;
}